import { c as _c } from "react/compiler-runtime";
import { DarkModeApplier } from "@components/common/dark-mode-applier";
import { SphereDialogProvider } from "@components/common/dialog/sphere-dialog-provider";
import { AuthProvider } from "@context-providers/auth/auth-provider";
import { KeyBindingsLoader } from "@loaders/key-bindings-loader";
import { QueryParamsLoader } from "@loaders/query-params-loader";
import { UserLoader } from "@loaders/user-loader";
import { Outlet } from "react-router-dom";

/**
 * Wrapper component that provides all context providers which depend on React Router.
 * These providers must be rendered inside `RouterProvider` because they internally
 * use React Router hooks (e.g. `useLocation`, `useNavigate`, `useParams`).
 * For this reason, they cannot be initialized at the root level (e.g. in `main.tsx`),
 * and instead must be placed within the routing context.
 *
 * @returns A composition of all route-scoped providers wrapping the current route `Outlet`.
 */
export function RouteScopedProviders() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SphereDialogProvider><QueryParamsLoader><KeyBindingsLoader><UserLoader><AuthProvider><DarkModeApplier /><Outlet /></AuthProvider></UserLoader></KeyBindingsLoader></QueryParamsLoader></SphereDialogProvider>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}